import { generateScopedActionCreator } from '@synthetica-ai/system';
const { createEffectAction } = generateScopedActionCreator('UI');
export const openSnackbar = createEffectAction('OPEN_SNACKBAR');
export const closeSnackbar = createEffectAction('CLOSE_SNACKBAR');
